import React from 'react';

const AdvancedTreeContainer = ({ children }) => {
  return (
    <div className="advtree">
      <div className="advtree-container">{children}</div>
    </div>
  );
};

export { AdvancedTreeContainer };
